export const MAX_CORRELATION_ID_LENGTH = 128

const CORRELATION_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]*$/

export const isValidCorrelationId = (
  value: string | null | undefined,
): value is string =>
  typeof value === 'string' &&
  value.length <= MAX_CORRELATION_ID_LENGTH &&
  CORRELATION_ID_PATTERN.test(value)
